export default __webpack_public_path__ + "static/transaction-actions-v2-38985396cea32a9b4dddccf1b5111920.png";